__turbopack_context__.v({
  "container": "BottomCallToAction-module__HpDVRW__container",
  "copyAlert": "BottomCallToAction-module__HpDVRW__copyAlert",
  "copyAlertContainer": "BottomCallToAction-module__HpDVRW__copyAlertContainer",
  "donateButton": "BottomCallToAction-module__HpDVRW__donateButton",
  "donateButtonContainer": "BottomCallToAction-module__HpDVRW__donateButtonContainer",
  "facebook": "BottomCallToAction-module__HpDVRW__facebook",
  "facebookMessenger": "BottomCallToAction-module__HpDVRW__facebookMessenger",
  "heading": "BottomCallToAction-module__HpDVRW__heading",
  "shareCta": "BottomCallToAction-module__HpDVRW__shareCta",
  "sharingButtonsContainer": "BottomCallToAction-module__HpDVRW__sharingButtonsContainer",
  "socialSharingButton": "BottomCallToAction-module__HpDVRW__socialSharingButton",
  "whatsapp": "BottomCallToAction-module__HpDVRW__whatsapp",
});
